import { simpleLookupConfig } from "../../../../records/lookup/config/simpleLookupConfig";
import { vsLookupManagementServiceProviderName } from "../../../shared/lookups";

export const vsObjectName = "machineCabinetType";

const url = "/api/machines/MachineCabinetType";

export const machineCabinetTypeLookupConfig = simpleLookupConfig(
  vsLookupManagementServiceProviderName,
  {
    name: vsObjectName,
    nameSingular: "CabinetType",
    url,
  }
);
